/* assets/src/viewer/settings.js
 * Lettura impostazioni viewer da window.ASG_Data.viewerSettings (white-label, backend).
 * Port fedele degli helper r128 (three-scene.js:10-133), invariati nel comportamento.
 */

export function clamp(value, min, max) {
  return Math.min(max, Math.max(min, value));
}

export function rawSettings() {
  return (window.ASG_Data && window.ASG_Data.viewerSettings) ? window.ASG_Data.viewerSettings : {};
}

export function isExplicitTrue(value) {
  return value === true || value === 1 || value === '1' || value === 'true' || value === 'yes' || value === 'on';
}

export function isExplicitFalse(value) {
  return value === false || value === 0 || value === '0' || value === 'false' || value === 'no' || value === 'off';
}

export function performanceMode(rawInput = null) {
  const raw = rawInput || rawSettings();
  const quality = String(raw.quality || raw.renderQuality || raw.renderMode || '').toLowerCase();
  if (quality === 'high' || quality === 'quality' || quality === 'ultra') return false;
  if (isExplicitFalse(raw.performanceMode)) return false;
  return true;
}

export function shouldUseGizmo() {
  const raw = rawSettings();
  return isExplicitTrue(raw.showGizmo) || isExplicitTrue(raw.gizmo) || isExplicitTrue(raw.axisGizmo);
}

export function getViewerSettings() {
  const raw = rawSettings();
  const perf = performanceMode(raw);
  return {
    exposure: clamp(parseFloat(raw.exposure != null ? raw.exposure : 1.0) || 1.0, 0.5, 1.8),
    autoRotate: !!raw.autoRotate,
    fov: clamp(parseInt(raw.fov != null ? raw.fov : 45, 10) || 45, 30, 90),
    performanceMode: perf,
    antialias: perf ? false : raw.antialias !== false,
    shadows: perf ? false : raw.shadows !== false,
    materialGlossiness: clamp(parseFloat(raw.materialGlossiness != null ? raw.materialGlossiness : 0.5) || 0.5, 0, 1),
    materialMetalness: clamp(parseFloat(raw.materialMetalness != null ? raw.materialMetalness : 0.1) || 0.1, 0, 1),
  };
}

const MOBILE_QUERY = '(max-width: 768px)';

export function isMobileViewer() {
  return typeof window !== 'undefined' && window.matchMedia && window.matchMedia(MOBILE_QUERY).matches;
}

// Cap adattivo del pixelRatio (port :110-133): riduce il costo GPU senza throttlare i controlli.
export function pixelRatioCap() {
  const ratio = window.devicePixelRatio || 1;
  const viewportWidth = window.innerWidth || document.documentElement.clientWidth || 0;

  if (performanceMode()) return 1;
  if (isMobileViewer()) return Math.min(Math.max(ratio, 1), 1.25);
  if (viewportWidth >= 1600) return Math.min(Math.max(ratio, 1), 1.25);
  if (viewportWidth >= 1200) return Math.min(Math.max(ratio, 1), 1.15);
  return Math.min(Math.max(ratio, 1), 1.1);
}
